module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo logo-width",
    attrs: {
      "span": 10
    }
  }, [_vm._v("海外新生活")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": _vm.userInfo.name
    }
  }), _vm._v(" " + _vm._s(_vm.userInfo.name) + "\n        ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "menu-expanded"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$router.path,
      "router": "",
      "unique-opened": ""
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("店铺信息设置")]), _vm._v(" "), _vm._l((_vm.shopInfo), function(shop) {
    return _c('el-menu-item', {
      key: shop.id,
      attrs: {
        "index": '/shop/' + shop.id + '/info'
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(shop.name) + "\n          ")])
  })], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-gift",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("商品管理")]), _vm._v(" "), _vm._l((_vm.shopInfo), function(shop) {
    return _c('el-menu-item', {
      key: shop.id,
      attrs: {
        "index": '/shop/' + shop.id + '/goods/list'
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(shop.name) + "\n          ")])
  })], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("订单管理")]), _vm._v(" "), _vm._l((_vm.shopInfo), function(shop) {
    return _c('el-menu-item', {
      key: shop.id,
      attrs: {
        "index": '/shop/' + shop.id + '/orders/list'
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(shop.name) + "\n          ")])
  })], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-date",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("团购管理")]), _vm._v(" "), _vm._l((_vm.shopInfo), function(shop) {
    return _c('el-menu-item', {
      key: shop.id,
      attrs: {
        "index": '/shop/' + shop.id + '/group/list'
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(shop.name) + "\n          ")])
  })], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-android",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("微信智能小海")]), _vm._v(" "), _vm._l((_vm.shopInfo), function(shop) {
    return (shop.enable_robot === 1) ? _c('el-menu-item', {
      key: shop.id,
      attrs: {
        "index": '/shop/' + shop.id + '/robot'
      }
    }, [_c('i', {
      staticClass: "fa fa-building-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(shop.name) + "\n          ")]) : _vm._e()
  })], 2), _vm._v(" "), (parseInt(_vm.userInfo.role) < 3) ? _c('el-menu-item', {
    attrs: {
      "index": "/groups"
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("群导航管理\n        ")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.userInfo.role) < 3) ? _c('el-menu-item', {
    attrs: {
      "index": "/views"
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("景点管理\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ab191f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/index.vue
// module id = 787
// module chunks = 1